import GeneralParamsServer from '../../server/generalParams';
import { addLoading, removeLoading } from './loading';

export const getGeneralParams = () => async () => GeneralParamsServer.getGeneralParams();

export const updateGeneralParams = (params, files) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await GeneralParamsServer.updateGeneralParams(params, files);
  } finally {
    dispatch(removeLoading());
  }
};
